import React, { useEffect, useState } from "react";
import Form from "react-bootstrap/Form";

import backend from "../../../backend";

const DrivePanel = () => {
  const [drive, setDrive]     = useState("");
  const [loading, setLoading] = useState(true);
  const [saving, setSaving]   = useState(false);
  const [msg, setMsg]         = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const r = await backend.get("data/drive");
        if (!cancelled) setDrive(r.data || "");
      } catch (err) {
        console.log(err);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  const submit = async () => {
    setMsg(null);
    setSaving(true);
    try {
      await backend.patch("data/drive", { drive });
      setMsg({ ok: true, text: "Carpeta de Drive guardada" });
    } catch (err) {
      setMsg({ ok: false, text: "Error: " + (err?.response?.data?.error || err.message) });
    }
    setSaving(false);
  };

  if (loading) {
    return <div style={{ color: "#cbd5e1", fontSize: 12 }}>Cargando…</div>;
  }

  return (
    <div>
      <div style={{
        fontSize: 12, fontWeight: 700, color: "#999",
        textTransform: "uppercase", letterSpacing: ".07em",
        margin: "0 0 10px",
      }}>
        Carpeta de Google Drive
      </div>

      <div style={{ maxWidth: 720 }}>
        {!drive && (
          <div style={{
            background: "rgba(0,0,0,0.25)", borderRadius: 6,
            padding: 14, marginBottom: 14, color: "#ccc", fontSize: 12, lineHeight: 1.6,
          }}>
            <div>
              Necesitas crear una carpeta en Google Drive y compartirla a este correo
              con el permiso de <span style={{ fontWeight: 700 }}>Editor</span>:
            </div>
            {/* wordBreak: en teléfono el correo largo baja de línea en vez de rebalsar */}
            <div style={{
              fontWeight: 700, textAlign: "center", margin: "8px 0",
              fontFamily: "ui-monospace,Menlo,Consolas,monospace", color: "#fff",
              wordBreak: "break-all",
            }}>
              worker@shared-folder-manager.iam.gserviceaccount.com
            </div>
            <div>
              Luego abrí la carpeta y mirá el URL, va a ser algo así:
            </div>
            <div style={{
              fontWeight: 700, textAlign: "center", margin: "8px 0",
              fontFamily: "ui-monospace,Menlo,Consolas,monospace", color: "#fff",
              wordBreak: "break-all",
            }}>
              https://drive.google.com/drive/u/0/folders/un_ID_muy_largo
            </div>
            <div>
              Copiá el <span style={{ fontWeight: 700 }}>ID</span> y pegalo abajo.
            </div>
          </div>
        )}

        <Form.Group>
          <Form.Label style={{ fontSize: 10, color: "#cbd5e1", textTransform: "uppercase", letterSpacing: ".05em" }}>
            ID Carpeta Compartida
          </Form.Label>
          <Form.Control
            onChange={e => setDrive(e.target.value)}
            value={drive}
            placeholder="1aBcDeFgHi…"
          />
        </Form.Group>

        {msg && (
          <div style={{
            marginTop: 14, fontSize: 11, padding: "7px 10px", borderRadius: 5,
            background: msg.ok ? "#0d2a15" : "#2d1515",
            color: msg.ok ? "#2ecc71" : "#e74c3c",
            border: `1px solid ${msg.ok ? "#0d4020" : "#4a2020"}`,
          }}>{msg.text}</div>
        )}

        <div style={{ marginTop: 16, display: "flex", justifyContent: "flex-end" }}>
          <button
            className="bini-btn bini-btn-save"
            onClick={submit}
            disabled={saving}
          >
            {saving ? "Guardando…" : "Guardar carpeta"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DrivePanel;
